var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",attrs:{"width":"320","height":"240"}})}
var staticRenderFns = []

export { render, staticRenderFns }